import styled, {css} from 'styled-components';

export const LogoContainer = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transform: scale(${({scale}) => scale});
    
    ${({position}) => position === 'absolute' && css`
        position: absolute;
        right: 15px;
    `};
    
    ${({mobile}) => mobile && css`
        @media (max-width: 992px) {
            right: 60px;
        }
        
        @media (max-width: 400px) {
            transform: scale(0.8);
        }
        
        @media (max-width: 350px) {
            transform: scale(0.7);
        }
        
        @media (max-width: 335px) {
            display: none;
        }
    `};
`;

export const DivContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
`;

export const FlexDiv = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin-left: 7px;
`;

export const StyledPartnerLogo = styled.img`
    width: ${({width}) => width ?? 30}px;
    height: ${({height}) => height ?? 30}px;
    
    ${({resizable}) => resizable && css`
        @media (max-width: 480px) {
            width: 15px;
            height: 15px;
        }
    `};
`;

export const StyledLink = styled.span`
    color: orange;
    font-family: Roboto Condensed, serif;
    font-size: 10px;
    letter-spacing: 2px;
    font-weight: bold;
`;

export const StyledDescription = styled.p`
    color: white;
    font-family: Roboto Condensed, serif;
    letter-spacing: 2px;
    text-transform: uppercase;
    font-size: 8px;
    font-weight: 300;
    margin: 0;
    margin-top: 3px;
    margin-bottom: 3px;
`;

export const StyledSign = styled.p`
    color: white;
    font-family: Caveat, serif;
    font-size: 12px;
    margin: 0;
    align-self: flex-end;
`;
